import { render } from "./ViewSortiePage.vue?vue&type=template&id=10579975&ts=true"
import script from "./ViewSortiePage.vue?vue&type=script&lang=ts"
export * from "./ViewSortiePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__